import { render } from "./Windows.vue?vue&type=template&id=92f8807a&scoped=true"
import script from "./Windows.vue?vue&type=script&lang=js"
export * from "./Windows.vue?vue&type=script&lang=js"

import "./Windows.vue?vue&type=style&index=0&id=92f8807a&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f8807a"]])

export default __exports__